import styled from 'styled-components';

export const NotFoundContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-block-start: 3.5rem;
  padding-block-end: 2rem;
  padding-inline: 1rem;
  max-width: 344px;
  margin: 0 auto;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  color: ${Styles.color.black};

  h1 {
    margin: 0;
    font-family: ${Styles.fontFamily.base};
    font-size: 1.5rem;
    line-height: 2.25rem;
    text-transform: capitalize;
  }

  p {
    margin-block-start: 0;
    margin-block-end: 1.25rem;
    margin-inline: 0;
    font-size: 1rem;
    line-height: 1.1rem;
  }

  button {
    width: 100%;
    height: 40px;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    line-height: 1rem;
  }

  button + button {
    margin-block-start: 1rem;
  }
`;
